const toggleButtons = document.querySelectorAll('[data-hero-video-toggle]');
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

toggleButtons.forEach((button) => {
    const wrapper = button.closest('.pane__background-video-wrapper');
    const iframe = wrapper ? wrapper.querySelector('iframe.video') : null;

    if (!iframe) return;

    let isPlaying = true;

    if (prefersReducedMotion) {
        iframe.src = iframe.src.replace('autoplay=1', 'autoplay=0');
        isPlaying = false;
        button.querySelector('.hero-video-toggle__icon--pause').classList.add('d-none');
        button.querySelector('.hero-video-toggle__icon--play').classList.remove('d-none');
        button.setAttribute('aria-label', 'Speel video af');
    }

    button.addEventListener('click', () => {
        if (isPlaying) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            button.querySelector('.hero-video-toggle__icon--pause').classList.add('d-none');
            button.querySelector('.hero-video-toggle__icon--play').classList.remove('d-none');
            button.setAttribute('aria-label', 'Speel video af');
        } else {
            iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            button.querySelector('.hero-video-toggle__icon--play').classList.add('d-none');
            button.querySelector('.hero-video-toggle__icon--pause').classList.remove('d-none');
            button.setAttribute('aria-label', 'Pauzeer video');
        }

        isPlaying = !isPlaying;
    });
});
